import { useState } from "react";

/**
 * 学习日志/Diff相关状态 Hook
 */
const useLearningState = () => {
  const [learningLog, setLearningLog] = useState([]);
  const [currentDiffMessageIndex, setCurrentDiffMessageIndex] = useState(null);
  const [activeTrainingMode, setActiveTrainingMode] = useState("portal"); // 默认进入课程入口面板

  // 重置学习状态
  const resetLearningState = () => {
    setLearningLog([]);
    setCurrentDiffMessageIndex(null);
    setActiveTrainingMode("portal");
  };

  return {
    learningLog,
    setLearningLog,
    currentDiffMessageIndex,
    setCurrentDiffMessageIndex,
    activeTrainingMode,
    setActiveTrainingMode,
    resetLearningState,
  };
};

export default useLearningState;
